import React, {useContext} from 'react';
import NodeHandles from './NodeHandles';
import {NodeData} from '../models';
import {LessonContentFreeformShapeChoice} from '../../../data/models/LessonContent/LessonContentBase';
import {EditorContext} from '../container/LessonEditorContainer';
import Tooltip from '../../../uiToolkit/Tooltip';

interface Props {
  data: NodeData;
}

const ChoiceFreeformShape = React.memo(({data}: Props) => {
  const context = useContext(EditorContext);

  const onClick = (e: any) => {
    context.setSelectedNode(data.payload, data.type);
    e.stopPropagation();
  };

  const getNode = () => {
    return data.payload as LessonContentFreeformShapeChoice;
  };

  return (
    <NodeHandles>
      <div className="EditorNodeContainer">
        {getNode().isCorrect !== null && (
          <div>
            {getNode().isCorrect ? (
              <span className="icon-typeCheck ChallengeCorrect"></span>
            ) : (
              <span className="icon-typeClose ChallengeIncorrect"></span>
            )}
          </div>
        )}
        <div
          onClick={onClick}
          className={`EditorCard ${
            context.selectedNode?.internalId === data.payload.internalId
              ? 'SelectedEditorCard'
              : ''
          } ForceWidthCard`}>
          <Tooltip tooltipText={getNode().title} greenTooltip>
            <p className="ChoiceQuestionNode">{getNode().title}</p>
          </Tooltip>
        </div>
      </div>
    </NodeHandles>
  );
});

export default ChoiceFreeformShape;
